import { ArrowForward } from '@mui/icons-material';
import { Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '../LoadingIndicator';
import React from 'react';

const NextButton = (props: { customSubmitText: string | null; isLoading: boolean; disabled: boolean }): JSX.Element => {
  const { t } = useTranslation('component');
  return (
    <>
      {props.isLoading && <LoadingIndicator sx={{ margin: '0 16px 0 0' }} />}
      <Box sx={{ minWidth: 160 }}>
        <Button
          fullWidth
          type="submit"
          variant="contained"
          id="RegisterSubmitButton"
          disabled={props.isLoading || props.disabled}
          endIcon={props.customSubmitText == null ? <ArrowForward /> : ''}>
          {props.customSubmitText == null ? t('Buttons.Next') : props.customSubmitText}
        </Button>
      </Box>
    </>
  );
};

const AllButtons = (props: {
  stepHandler: (value: number | ((prevVar: number) => number)) => void;
  currentStep: number;
  hasPrevious: boolean;
  hasSkip: boolean;
  customSubmitText: string | null;
  isLoading: boolean;
  disabled: boolean;
  skipCustomEvent?: () => void;
}): JSX.Element => {
  const { t } = useTranslation('component');

  const onClickSkip = () => {
    if (props.skipCustomEvent) {
      props.skipCustomEvent();
    }
    props.stepHandler(props.currentStep + 1);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row-reverse', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {props.hasSkip && (
          <Button
            sx={{ marginRight: '16px' }}
            size="large"
            onClick={onClickSkip}
            disabled={props.isLoading || props.disabled}
            variant="outlined">
            {t('Buttons.Skip')}
          </Button>
        )}
        <NextButton customSubmitText={props.customSubmitText} isLoading={props.isLoading} disabled={props.disabled} />
      </Box>
      {props.hasPrevious && (
        <Button onClick={() => props.stepHandler(props.currentStep - 1)} disabled={props.isLoading || props.disabled}>
          {t('Buttons.Previous')}
        </Button>
      )}
    </Box>
  );
};

const ProgressButtons = (props: {
  stepHandler: (value: number | ((prevVar: number) => number)) => void;
  currentStep: number;
  hasPrevious: boolean;
  hasSkip: boolean;
  customSubmitText: string | null;
  isLoading: boolean;
  disabled?: boolean;
  skipCustomEvent?: () => void;
}): JSX.Element => {
  const disabled = props.disabled || false;
  let button;
  if (!props.hasPrevious && !props.hasSkip) {
    button = (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row-reverse' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <NextButton customSubmitText={props.customSubmitText} isLoading={props.isLoading} disabled={disabled} />
        </Box>
      </Box>
    );
  } else {
    button = (
      <AllButtons
        stepHandler={props.stepHandler}
        currentStep={props.currentStep}
        hasPrevious={props.hasPrevious}
        hasSkip={props.hasSkip}
        skipCustomEvent={props.skipCustomEvent}
        customSubmitText={props.customSubmitText}
        isLoading={props.isLoading}
        disabled={disabled}
      />
    );
  }
  return <>{button}</>;
};

export default ProgressButtons;
